import { TripInformationFieldNames } from '@contracts/order/fields/TripInformationFields';
import {
  BooleanField,
  DateField,
  PositiveFloatField,
  PositiveIntegerField,
  StringField,
} from '@src/permitField/PermitFields';
import type { NumberSchema, StringSchema } from 'yup';
import * as yup from 'yup';

export const TripsFormName = 'trips';

export class TripOriginalOriginField extends StringField {
  public static fieldName = TripInformationFieldNames.TripOriginalOrigin;
}

export class TripFinalDestinationField extends StringField {
  public static fieldName = TripInformationFieldNames.TripFinalDestination;
}

export class TripOriginField extends StringField {
  public static fieldName = TripInformationFieldNames.TripOrigin;
}

export class TripDestinationField extends StringField {
  public static fieldName = TripInformationFieldNames.TripDestination;
}

export class TripBaseRegisteredWeightField extends PositiveFloatField {
  public static fieldName = TripInformationFieldNames.TripBaseRegisteredWeight;
}

export class TripRouteField extends StringField {
  public static fieldName = TripInformationFieldNames.TripRoute;
}

export class TripMileageField extends PositiveIntegerField {
  public static fieldName = TripInformationFieldNames.TripMileage;
}

export class TripIncludesReturnTripField extends BooleanField {
  public static fieldName = TripInformationFieldNames.TripIncludesReturnTrip;
}

export class TripReturnDestinationField extends StringField {
  public static fieldName = TripInformationFieldNames.TripReturnDestination;
  public static validator: StringSchema = yup
    .string()
    .when(TripIncludesReturnTripField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class TripReturnRouteField extends StringField {
  public static fieldName = TripInformationFieldNames.TripReturnRoute;
  public static validator: StringSchema = yup
    .string()
    .when(TripIncludesReturnTripField.fieldName, {
      is: true,
      then: (schema) => schema.trim().required(),
    });
}

export class TripReturnMileageField extends PositiveIntegerField {
  public static fieldName = TripInformationFieldNames.TripReturnMileage;
  public static validator: NumberSchema = yup
    .number()
    .transform((value) => (!value ? undefined : value))
    .when(TripIncludesReturnTripField.fieldName, {
      is: true,
      then: (schema) =>
        schema.typeError('isNumber').positive().integer().required(),
    });
}

export class EffectiveDateField extends DateField {
  public static fieldName = TripInformationFieldNames.EffectiveDate;
}

export class EffectiveDateTimeField extends DateField {
  public static fieldName = TripInformationFieldNames.EffectiveDateTime;
}

export function stateTripFieldNames() {
  // Include effectiveDateTime for display purposes, even though it's not in the validation schema
  return [...Object.keys(tripsFields), EffectiveDateTimeField.fieldName];
}

export function globalTripFieldNames() {
  return Object.keys(globalTripsFields);
}

export function allTripFieldNames() {
  return [...stateTripFieldNames(), ...globalTripFieldNames()];
}

export const returnTripFields = {
  [TripIncludesReturnTripField.fieldName]:
    TripIncludesReturnTripField.validator,
  [TripReturnDestinationField.fieldName]: TripReturnDestinationField.validator,
  [TripReturnRouteField.fieldName]: TripReturnRouteField.validator,
  [TripReturnMileageField.fieldName]: TripReturnMileageField.validator,
};
export const tripsFields = {
  [TripOriginField.fieldName]: TripOriginField.validator,
  [TripDestinationField.fieldName]: TripDestinationField.validator,
  [TripBaseRegisteredWeightField.fieldName]:
    TripBaseRegisteredWeightField.validator,
  [TripRouteField.fieldName]: TripRouteField.validator,
  [TripMileageField.fieldName]: TripMileageField.validator,
  [EffectiveDateField.fieldName]: EffectiveDateField.validator,
  ...returnTripFields,
};

export const globalTripsFields = {
  [TripOriginalOriginField.fieldName]: TripOriginalOriginField.validator,
  [TripFinalDestinationField.fieldName]: TripFinalDestinationField.validator,
};
